import { NgModule } from '@angular/core';
// Must be important only once and here
import { BrowserModule, DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';
// Not documented, but throws "BrowserModule" is imported twice if in shared module see https://github.com/angular/angular-cli/issues/5684
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
// modules
import { AppRoutingModule } from './app-routing.module';
import { SharedModule } from './shared/shared.module';
import { CoreModule } from './core/core.module';
import { LayoutModule } from './layout/layout.module';
import { AgentsModule } from './agents/agents.module';
// components
import { AppComponent } from './app.component';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { HttpErrorInterceptor } from './core/http-error.interceptor';
import { AuthInterceptor } from './core/auth.interceptor';
import { TargetSiteInterceptor } from './core/target-site.interceptor';
import { WidgetWriteInterceptor } from './core/widget-writes/widget-write.interceptor';
import { OVERLAY_POPOVER_OPT_OUT } from './core/overlay-popover.provider';
import { FlyoutModule } from './flyout/flyout.module';
import { DataExportsModule } from './data-exports/data-exports.module';
import { DatePipe } from '@angular/common';
import { CustomersService } from './customers/customers.service';
import { registerLocaleData } from '@angular/common';
import localeSv from '@angular/common/locales/sv';
import { MatSelectModule } from '@angular/material/select';
import { CurrentContextService } from './core/current-context.service';
import { MonacoEditorModule, NgxMonacoEditorConfig } from 'ngx-monaco-editor-v2';
import { AdminSettingsModalComponent } from './shared/admin-settings-modal/admin-settings-modal.component';
import { ConfigureMarketAccountModalComponent } from './shared/configure-market-account-modal/configure-market-account-modal.component';
import { registerLightJavascript } from './shared/code-editor/light-javascript-language';

const monacoConfig: NgxMonacoEditorConfig = {
  baseUrl: 'assets', // Point to the assets folder
  defaultOptions: { scrollBeyondLastLine: false },
  onMonacoLoad: registerLightJavascript,
};

registerLocaleData(localeSv);

const providers: Array<any> = [DatePipe, CustomersService, CurrentContextService];

/**
 *  LowerCaseUrlSerializer transform url to lowercase. In some cases we need keep case sensitive
 *  Ex: decrypt base64
 */
// providers.push({provide: UrlSerializer, useClass: LowerCaseUrlSerializer});
providers.push({
  provide: HTTP_INTERCEPTORS,
  useClass: HttpErrorInterceptor,
  multi: true,
});
// Must be registered AFTER HttpErrorInterceptor so the 401 refresh+retry runs before the
// generic error interceptor sees anything.
providers.push({
  provide: HTTP_INTERCEPTORS,
  useClass: AuthInterceptor,
  multi: true,
});
providers.push({
  provide: HTTP_INTERCEPTORS,
  useClass: TargetSiteInterceptor,
  multi: true,
});
providers.push({
  provide: HTTP_INTERCEPTORS,
  useClass: WidgetWriteInterceptor,
  multi: true,
});
providers.push(OVERLAY_POPOVER_OPT_OUT);

// Do not register anything here. Use either feature modules or shared/core.
@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    SharedModule,
    AppRoutingModule,
    CoreModule,
    LayoutModule,
    AgentsModule,
    FlyoutModule,
    DataExportsModule,
    MatSelectModule,
    MonacoEditorModule.forRoot(monacoConfig),
    AdminSettingsModalComponent,
    ConfigureMarketAccountModalComponent,
  ],
  declarations: [AppComponent],
  providers: [providers],
  exports: [],
  bootstrap: [AppComponent], // Entry-point
})
export class AppModule {
  constructor(iconRegistry: MatIconRegistry, sanitizer: DomSanitizer) {
    // Namespaced so a sprite name can never collide with a Material ligature.
    iconRegistry.addSvgIconSetInNamespace(
      'tb',
      sanitizer.bypassSecurityTrustResourceUrl('assets/icons/triggerbee-icons.svg'),
    );
  }
}
